'use client'

import posthog from 'posthog-js'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Replaces the root layout, so it is the last place a render error can be
  // reported from the browser. Dropped while the visitor has not consented.
  useEffect(() => {
    posthog.captureException(error, { digest: error.digest })
  }, [error])

  return (
    <html>
      <body
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          padding: '3rem 1.5rem',
          textAlign: 'center',
          color: '#111',
        }}
      >
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', fontWeight: 600 }}>
          Something went wrong
        </h1>
        <p style={{ color: '#555', marginBottom: '1.5rem', maxWidth: '32rem', margin: '0 auto 1.5rem' }}>
          The application encountered an unrecoverable error.
        </p>
        {error.digest && (
          <p style={{ color: '#999', fontSize: '0.75rem', marginBottom: '1rem' }}>
            Reference:
            {' '}
            {error.digest}
          </p>
        )}
        <button
          onClick={() => reset()}
          style={{
            padding: '0.5rem 1.25rem',
            borderRadius: '0.375rem',
            border: '1px solid #ddd',
            background: '#fff',
            cursor: 'pointer',
            fontSize: '0.875rem',
          }}
        >
          Reload
        </button>
      </body>
    </html>
  )
}
